/* eslint-disable react/prop-types */
import Image from 'next/image';
import Link from 'next/link';

export default function GuideSection() {
  return (<div>
    <Link href={"/thi-tinh-huong/meo-thi/"} passHref>
      <Image src={"/icons/meo-lam-bai.png"} style={{ borderRadius: 5, cursor: 'pointer' }} alt="mẹo làm bài" height={103} width={272} sizes='cover' />
    </Link>
  </div>);
}

